export default function getIsSystemAdmin(state: any) {
  return state.getIn(['currentUser', 'data', 'isSystemAdmin'], false);
}
